// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8413 ? "1329d575" : chunkId) + "." + {"944":"547af6380ec98348","3976":"ad3eb86de267aa6b","8413":"22656c901326bab7"}[chunkId] + ".js";
};